import { useEffect } from 'react';
import { listenLoading } from '../../channels/loadingChannel';
import { useLoadingStore } from '../../stores/useLoadingStore';

export function useLoadingChannel() {

    useEffect(() => {

        const unsubscribe =
            listenLoading((state) => {

                useLoadingStore
                    .getState()
                    .applyLoadingState(state);

            });

        return unsubscribe;

    }, []);

}